import { JSResourceForUserVisible } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';

export const liveChatMyChatsEntryPoint = createEntryPoint({
	root: JSResourceForUserVisible(
		() =>
			import(
				/* webpackChunkName: "async-servicedesk-live-chat-my-chats", jiraSpaEntry: "async-servicedesk-live-chat-my-chats" */ './src'
			),
	),
	getPreloadProps: () => ({}),
});
